var Axis = require('./base');

Axis.Base = Axis;
Axis.Circle = require('./circle');
Axis.Grid = require('./grid');
Axis.Helix = require('./helix');
Axis.Line = require('./line');
Axis.Polyline = require('./polyline');
module.exports = Axis;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/lib/axis/index.js
// module id = 344
// module chunks = 0 1 2